import { VideoStabilizationIcon } from './VideoStabilizationIcon';

/**
 * author: Google
 * id DF10672F-0064-47B8-A327-797095F0F6A1
 * name video-stabilization
 * version: 2.3.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/video-stabilization.svg
 * tags
 * - Video / Movie 
 */
export const VideoStabilisationIcon = VideoStabilizationIcon;
export default VideoStabilisationIcon